function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import constants from '../constants/formModalConstants';
import contentChangeActionFactory from './factories/contentChangeActionFactory';
import changeActionFactory from './factories/changeActionFactory';
import uploadActionFactory from './factories/uploadActionFactory';
import entityActionFactory from './factories/entityActionFactory';
const changeActions = changeActionFactory('formModal', 'forms');
const entityActions = entityActionFactory('formModal', 'forms');
const contentChangeActions = contentChangeActionFactory('formModal', 'forms', true, 'Photo');
const uploadActions = uploadActionFactory('formModal', 'forms');
const open = payload => ({
  type: constants.OPEN,
  payload
});

/**
 *  Seed the modal draft (`active`/`activeCache`) without showing the shared modal dialog. Callers
 *  that render `EditorComponent` inside a dialog of their own - the feedback panel - supply the
 *  chrome themselves and must not pop the `FormModal` the page behind them already mounts.
 */
const loadDraft = payload => ({
  type: constants.OPEN,
  payload: _objectSpread(_objectSpread({}, payload), {}, {
    open: false
  })
});
const close = () => ({
  type: constants.CLOSE
});
const setEditorCacheValue = (name, value) => ({
  type: constants.SET_EDITOR_CACHE_VALUE,
  name,
  value
});
const setEditorCacheValueFromDeferred = (id, content) => ({
  type: constants.SET_EDITOR_CACHE_VALUE_FROM_DEFERRED,
  id,
  content
});
export default _objectSpread(_objectSpread(_objectSpread(_objectSpread({
  change: contentChangeActions.change,
  getEntityRoute: contentChangeActions.getEntityRoute,
  open,
  loadDraft,
  close,
  setEditorCacheValue,
  setEditorCacheValueFromDeferred
}, entityActions), uploadActions), changeActions), contentChangeActions);